import { makeStyles } from '@material-ui/core';
import { themeColor } from 'src/mui-theme';

const quickViewWidth = {
  '@media (min-width: 1020px)': {
    width: '24vw',
  },
  '@media (min-width: 1020px) and (max-width: 1100px) and (min-height: 760px)': {
    width: '25.4vw',
  },
  '@media (min-width: 1150px)': {
    width: '24vw',
  },
  '@media (min-width: 1300px)': {
    width: '24vw',
  },
  '@media (min-width: 1500px)': {
    width: '21vw',
  },
  '@media (min-height: 999px)': {
    width: '24vw',
  },
};

export const styles = makeStyles(() => ({
  quickView: {
    backgroundColor: themeColor.white,
    border: `1px solid ${themeColor.secondaryLight}`,
    height: '100%',
    width: '25.4vw',
    ...quickViewWidth,
  },

  leftHanded: {
    marginLeft: '1.1vw',
    marginRight: '0',
  },

  rightHanded: {
    marginLeft: '0',
    marginRight: '1.1vw',
  },

  quickViewToggleButton: {
    padding: 0,
    width: '25.4vw',
    margin: '-1px -1px 0 -1px',
    ...quickViewWidth,
  },

  quickViewToggleButtonLabel: {
    alignItems: 'center',
    justifyContent: 'center',
    ...quickViewWidth,
  },

  itemList: {
    width: '-webkit-fill-available',
    flexGrow: 1,
  },

  innerItemList: {
    height: '100%',
  },

  itemLine: {
    height: 'calc(100%/8)',
  },

  itemLabel: {
    alignSelf: 'center',
    alignContent: 'center',
    width: '47.6923076923%',
    textAlignLast: 'left',
    paddingLeft: '5.04%',
  },

  itemLabelText: {
    display: '-webkit-box',
    overflow: 'hidden',
    wordBreak: 'break-word',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
  },

  itemQuantity: {
    alignSelf: 'center',
    alignContent: 'center',
    width: '26.1538461539%',
    textAlignLast: 'right',
  },

  itemQuantityText: {
    color: themeColor.subheaderLight,
    display: '-webkit-box',
    overflow: 'hidden',
    fontSize: '1.125rem',
    maxHeight: '3.3rem',
    wordBreak: 'break-word',
    fontWeight: 500,
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
  },

  itemButton: {
    height: '75%',
    width: '66%',
    padding: 0,
  },

  iconRoot: {
    textAlign: 'center',
  },

  imageIcon: {
    display: 'flex',
    height: 'inherit',
    width: 'inherit',
  },

  quickViewButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    width: '26.1538461539%',
    height: '100%',
  },

  quickViewButton: {
    alignItems: 'center',
    display: 'flex',
    width: 'auto',
    justifyContent: 'end',
  },

  cartIcon: {
    display: 'block',
    paddingLeft: '3.8461538462%',
  },

  itemsAddedLabel: {
    fontSize: '1rem',
    paddingLeft: '3.0769230769%',
  },

  chevronIcon: {
    display: 'block',
    paddingLeft: '5.3846153846%',
  },

  paginationContainer: {
    height: '12.3364486%',
  },
}));
